import Slider from './Slider.connect';
import { getComponentState, getValue } from './Slider.selectors';

Slider.selectors = {
	getComponentState,
	getValue,
};

export default Slider;
